/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { generalTheme, settingsTheme, baseUnit } from '../constants/dropdowns';

const customTheme = theme => ({
  ...theme,
  borderRadius: 2,
  baseUnit,
});

const DropdownIndicator = props => (
  <components.DropdownIndicator {...props}>
    <FontAwesomeIcon icon={faCaretDown} />
  </components.DropdownIndicator>
);

export default class NavigationItemPicker extends PureComponent {
  render() {
    const {
      value, options, onChange, placeholder, noOptionsMessage, theme, selectId,
    } = this.props;
    const isGeneral = theme === 'general';

    return (
      <Select
        id={selectId}
        instanceId={selectId}
        isSearchable={false}
        theme={customTheme}
        styles={isGeneral ? generalTheme : settingsTheme}
        components={{ DropdownIndicator }}
        value={value}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        noOptionsMessage={noOptionsMessage}
      />
    );
  }
}

NavigationItemPicker.propTypes = {
  selectId: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  noOptionsMessage: PropTypes.func,
};
